import { render, staticRenderFns } from "./IndicatorFormula.vue?vue&type=template&id=5d04620a"
import script from "./IndicatorFormula.vue?vue&type=script&lang=js"
export * from "./IndicatorFormula.vue?vue&type=script&lang=js"
import style0 from "./IndicatorFormula.vue?vue&type=style&index=0&id=5d04620a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports